export const environment = {
  production: false,
  DEBUG_ENABLED: 1,
  IPDATA_KEY: 'af338b03c73cd319c3126f0289370ae80544784a79d59032cbbc616f',
  IPDATA_API: 'https://api.ipdata.co',

  

  // LOCAL
  // ENV: 'Local',
  // REDIRECT_URL: 'http://localhost:4200/',
  // BASE_PATH: 'http://localhost:4200/',
  // S3_BASE_URL:'https://oraltech-dev.s3.amazonaws.com/',
  // AES_ENC_SECRET_KEY:'dDkWyTcpancwALsZF7PB3b5KCKvmirxn',
  // AES_ENC_IV:'f09c01zyc2x5HdhG',
  // API_BASE_URL:'http://localhost/oraltech/api/app/v2/',
  // AUTHORIZATION_KEY:'Rwvf4MESc6fYp_wN7rLBXehH9yuHmsMWfuUdftCif96L6WG3MLkGS7PjD7_kvERCcXhxpe',
  // AWS_ACCESS_KEY:'AKIAIRXQ236F5ALITKAA',
  // AWS_SECRET_KEY:'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',
  // S3_BUCKET_NAME:'oraltech-dev',
  // CONSENT_FORM: 'https://www.smilo.ai/consent-form/',
  // PRIVACY: 'https://www.smilo.ai/privacy-policy/',
  // TERMS: 'https://www.smilo.ai/terms-and-conditions/',
  // LICENCE_AGREEMENT : 'https://www.smilo.ai/licence-agreement/', 
  // SMILO_TOKEN: 'kH77APu19nwS06uIFultsejBUlT6SsMappz9PbuoH3W2L66bXA',
  // FBPIXEL_ID: '2991056137877291',
  // GTM_ID: 'UA-213928610-1',
  // GA_TRACKING_ID:'G-80D361EWJK',
  // TITLE_PREFIX: 'Smilo.ai - ' 

  // DEV
  // ENV: 'Dev',
  // REDIRECT_URL: 'https://projects.appdevelopment.com/oraltech_dev_871293/widget/',
  // BASE_PATH: 'https://projects.appdevelopment.com/oraltech_dev_871293/widget/',
  // S3_BASE_URL: 'https://oraltech-dev.s3.amazonaws.com/',
  // AES_ENC_SECRET_KEY: 'dDkWyTcpancwALsZF7PB3b5KCKvmirxn',
  // AES_ENC_IV: 'f09c01zyc2x5HdhG',
  // API_BASE_URL: 'https://projects.appdevelopment.com/oraltech_dev_871293/api/app/v2/',
  // AUTHORIZATION_KEY: 'Rwvf4MESc6fYp_wN7rLBXehH9yuHmsMWfuUdftCif96L6WG3MLkGS7PjD7_kvERCcXhxpe',
  // AWS_ACCESS_KEY: 'AKIAIRXQ236F5ALITKAA',
  // AWS_SECRET_KEY: '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',
  // S3_BUCKET_NAME: 'oraltech-dev',
  // CONSENT_FORM: 'https://www.smilo.ai/consent-form/',
  // PRIVACY: 'https://www.smilo.ai/privacy-policy/',
  // TERMS: 'https://www.smilo.ai/terms-and-conditions/',
  // LICENCE_AGREEMENT : 'https://www.smilo.ai/licence-agreement/', 
  // SMILO_TOKEN: 'kH77APu19nwS06uIFultsejBUlT6SsMappz9PbuoH3W2L66bXA',
  // FBPIXEL_ID: '2991056137877291',
  // GTM_ID: 'G-PBT0YPT5HG',
  // GA_TRACKING_ID:'G-80D361EWJK',
  // TITLE_PREFIX: 'Smilo.ai - ' 

  // QA
  // ENV: 'QA',
  // REDIRECT_URL: 'https://projects.appdevelopment.com/oraltech_qa_195629/widget/',
  // BASE_PATH: 'https://projects.appdevelopment.com/oraltech_qa_195629/widget/',
  // S3_BASE_URL:'https://oraltech-qa.s3.amazonaws.com/',
  // AES_ENC_SECRET_KEY:'dDkWyTcpancwALsZF7PB3b5KCKvmirxn',
  // AES_ENC_IV:'f09c01zyc2x5HdhG',
  // API_BASE_URL:'https://projects.appdevelopment.com/oraltech_qa_195629/api/app/v2/',
  // AUTHORIZATION_KEY:'Rwvf4MESc6fYp_wN7rLBXehH9yuHmsMWfuUdftCif96L6WG3MLkGS7PjD7_kvERCcXhxpe',
  // AWS_ACCESS_KEY:'AKIAIRXQ236F5ALITKAA',
  // AWS_SECRET_KEY:'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',
  // S3_BUCKET_NAME:'oraltech-qa',
  // CONSENT_FORM: 'https://www.smilo.ai/consent-form/',
  // PRIVACY: 'https://www.smilo.ai/privacy-policy/',
  // TERMS: 'https://www.smilo.ai/terms-and-conditions/',
  // LICENCE_AGREEMENT : 'https://www.smilo.ai/licence-agreement/', 
  // SMILO_TOKEN: 'pLfAZ7kypUg5mmkTxvXsRItFEZpZjgyjDvpDNfGmHubaPJ1xOf',
  // FBPIXEL_ID: '1281636479006304',
  // GTM_ID: 'G-X8K2GBLQG8',
  // GA_TRACKING_ID:'G-80D361EWJK',
  // TITLE_PREFIX: 'Smilo.ai - '



  // STAGING
  ENV: 'Staging',
  REDIRECT_URL: 'https://d1g7yybdsr7o3w.cloudfront.net/',
  BASE_PATH: 'https://projects.appdevelopment.com/oraltech_staging_910729/widget/',
  S3_BASE_URL: 'https://oraltech-staging.s3.amazonaws.com/',
  AES_ENC_SECRET_KEY: 'dDkWyTcpancwALsZF7PB3b5KCKvmirxn',
  AES_ENC_IV: 'f09c01zyc2x5HdhG',
  API_BASE_URL: 'https://projects.appdevelopment.com/oraltech_staging_910729/api/app/v2/',
  AUTHORIZATION_KEY: 'Rwvf4MESc6fYp_wN7rLBXehH9yuHmsMWfuUdftCif96L6WG3MLkGS7PjD7_kvERCcXhxpe',
  AWS_ACCESS_KEY: 'AKIAIRXQ236F5ALITKAA',
  AWS_SECRET_KEY: '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',
  S3_BUCKET_NAME: 'oraltech-staging',
  CONSENT_FORM: 'https://www.smilo.ai/consent-form/',
  PRIVACY: 'https://www.smilo.ai/privacy-policy/',
  TERMS: 'https://www.smilo.ai/terms-and-conditions/',
  LICENCE_AGREEMENT : 'https://www.smilo.ai/licence-agreement/', 
  SMILO_TOKEN: 'znzefhnYid36JfNqkvwOguE4krWgEOVyMS4vm6Ej5RjjszEroP',
  FBPIXEL_ID: '1281636479006304',
  GTM_ID: 'G-Y9KMZJD340',
  GA_TRACKING_ID:'G-80D361EWJK',
  TITLE_PREFIX: 'Smilo.ai - '

  //PRODUCTION
  // ENV: 'Production',
  // REDIRECT_URL: '/',
  // BASE_PATH: '/',   // for productions
  // //BASE_PATH: 'https://campaigns.smiloaiweb.com/',   //for campaigns
  // S3_BASE_URL: 'https://smilo-ai-live.s3-ap-southeast-2.amazonaws.com/',
  // AES_ENC_SECRET_KEY: 'dDkWyTcpancwALsZF7PB3b5KCKvmirxn',
  // AES_ENC_IV: 'f09c01zyc2x5HdhG',
  // API_BASE_URL: 'https://secure-api.smilo.ai/api/app/v2/',
  // AUTHORIZATION_KEY: 'Rwvf4MESc6fYp_wN7rLBXehH9yuHmsMWfuUdftCif96L6WG3MLkGS7PjD7_kvERCcXhxpe',
  // AWS_ACCESS_KEY: 'AKIAWCDD25BTA3RL5VMB',
  // AWS_SECRET_KEY: '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',
  // S3_BUCKET_NAME: 'smilo-ai-live',
  // CONSENT_FORM: 'https://www.smilo.ai/consent-form/',
  // PRIVACY: 'https://www.smilo.ai/privacy-policy/',
  // TERMS: 'https://www.smilo.ai/terms-and-conditions/',
  // LICENCE_AGREEMENT : 'https://www.smilo.ai/licence-agreement/', 
  // SMILO_TOKEN: 'mh4bCT5UW2SM5TWI4ckBNwq1BmjlDVemcnHT8W4Pm6ejpGVKef',
  // FBPIXEL_ID: '1281636479006304',
  // GTM_ID: 'G-Y9KMZJD340',
  // GA_TRACKING_ID:'G-NCQHVNT6YS', // for productions
  // //GA_TRACKING_ID:'G-W2FDF2VH4R', //for campaigns
  // TITLE_PREFIX: 'Smilo.ai - '
};
